import Repository from './Repository';

export default class CustomerRepository {
  static getCustomerContract() {
    return Repository.post('contract/get');
  }

  static getCustomerInvoiceData() {
    return Repository.post('customer/get-invoice-data');
  }

  static getBackendDeliveries() {
    return Repository.post('customer/get-deliveries');
  }
}
